
function calculateBitrate(fileSizeInBytes, durationInSeconds) {
  // Convert file size to bits
  const fileSizeInBits = fileSizeInBytes * 8

  // Calculate bitrate
  const bitrate = fileSizeInBits / durationInSeconds

  return Math.round(bitrate)
}

function getVideoPixel(width ,height) {
  return `${width}x${height}`
}


export {
  calculateBitrate,
  getVideoPixel
}